import $ from 'jquery';

import manualPaymentsView from './templates/manual-payments-view.hbs';
import Decimal from 'app/src/data/base/Decimal';
import Format from 'app/src/data/Format';
import Localize from 'app/src/localize/Localize';
import BaseItemView from 'app/src/views/base/BaseItemView';

const _Event = {
  ENTER_CARD_NUMBER_CLICKED: 'enter:card:number:clicked',
  CANCEL_MANUAL_PAYMENT_CLICKED: 'cancel:button:clicked',
};

// configure
let View = BaseItemView.extend({
  template: manualPaymentsView,

  ui: {
    enterCardNumberButton: '.enter-card-number',
    manualCreditCardForm: '#manual_credit_card',
    cancelButton: '#cancel-manual-payment',
  },

  events: {
    'click @ui.enterCardNumberButton': 'onEnterCardNumberButtonClicked',
  },

  triggers: {
    'click @ui.cancelButton': _Event.CANCEL_MANUAL_PAYMENT_CLICKED,
  },
});

// Defined
export default class PaymentManualCreditDebitView extends View {
  // Handlebars Template to use
  getTemplate() {
    return manualPaymentsView;
  }

  /**
   * Event Handler for when the Button for "Enter Card Number" is pressed
   * Triggers an event along with the FormData containing the Customer's info
   */
  onEnterCardNumberButtonClicked() {
    this.trigger(_Event.ENTER_CARD_NUMBER_CLICKED, this.ui.manualCreditCardForm.serializeArray());
  }
}
